import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface ProductGiftRecord {
  id: number;
  pool_name: string;
  pool_type: string;
  user_id: number;
  user_nickname: string;
  user_mobile: string;
  gift_product_name: string;
  gift_product_recycle_price: number;
  box_id: number;
  created_at: string;
}

@Module
export default class ProductGiftRecordModule extends VuexModule {
  product_gift_records_list = [] as Array<ProductGiftRecord>;
  product_gift_records_count = 0;
  ranking_list = [] as Array<any>;
  ranking_count = 0;

  get currentProductGiftRecordsList(): Array<ProductGiftRecord> {
    return this.product_gift_records_list;
  }

  get currentProductGiftRecordsCount(): number {
    return this.product_gift_records_count;
  }

  get currentRankingList() { return this.ranking_list; }
  get currentRankingCount() { return this.ranking_count; }

  @Mutation
  [Mutations.SET_PRODUCT_GIFT_RECORDS_LIST](list: Array<ProductGiftRecord>) {
    this.product_gift_records_list = list;
  }

  @Mutation
  [Mutations.SET_PRODUCT_GIFT_RECORDS_COUNT](count: number) {
    this.product_gift_records_count = count;
  }

  @Mutation
  [Mutations.SET_PRODUCT_GIFT_RECORD_RANKING](list: Array<any>) { this.ranking_list = list; }

  @Mutation
  [Mutations.SET_PRODUCT_GIFT_RECORD_RANKING_COUNT](count: number) { this.ranking_count = count; }

  @Action
  [Actions.GET_PRODUCT_GIFT_RECORDS](params: Record<string, unknown>) {
    ApiService.setHeader();

    let queryString = "?";
    if (params) {
      Object.keys(params).forEach((key) => {
        if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
          queryString += "&" + key + "=" + params[key];
        }
      });
    }

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/product_gift_records", queryString)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_PRODUCT_GIFT_RECORDS_LIST, data["product_gift_records"] || []);
          this.context.commit(Mutations.SET_PRODUCT_GIFT_RECORDS_COUNT, data["total_result"] || 0);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }

  @Action
  [Actions.GET_PRODUCT_GIFT_RECORD_RANKING](params: Record<string, unknown>) {
    ApiService.setHeader();
    let qs = "?";
    if (params) {
      Object.keys(params).forEach((k) => {
        if (params[k] !== undefined && params[k] !== null && params[k] !== '') {
          qs += (qs === "?" ? "" : "&") + k + "=" + params[k];
        }
      });
    }
    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/product_gift_records", "ranking" + qs)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_PRODUCT_GIFT_RECORD_RANKING, data["rankings"] || []);
          this.context.commit(Mutations.SET_PRODUCT_GIFT_RECORD_RANKING_COUNT, data["total_result"] || 0);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }
}
